import Preview from "../../../../src/pages/tutorial/Preview";
import React from 'react';
export default {
  Preview,
  React
};